import SimpleMessageEditor from './SimpleMessageEditor.vue'

export default SimpleMessageEditor;
